import { styled, MenuItem, Button as ButtonMui } from '@mui/material';

export const NavbarWrapper = styled('div')({
  margin: '5px 0',
  display: 'flex',
});

export const NavbarMenu = styled('ul')({
  padding: 0,
  margin: 0,
  listStyle: 'none',
  display: 'flex',
  flexWrap: 'nowrap',
  gap: '10px',
  overflow: 'hidden',
});

export const NavbarMenuItem = styled('li')({
  color: 'rgba(0, 71, 99, 1)',
  fontWeight: 500,
  fontSize: '14px',
  textTransform: 'uppercase',
  borderRadius: '29px',
  padding: '5px 9px',
  cursor: 'pointer',
  textWrap: 'nowrap',
  '&:hover': {
    color: 'white',
    backgroundColor: 'rgba(0, 71, 99, 1)',
  },
  '&.selected': {
    color: 'white',
    backgroundColor: 'rgba(0, 71, 99, 1)',
  }
});

export const DropdownMenuItem = styled(MenuItem)({
  minWidth: '250px',
  color: 'rgba(28, 61, 100, 1)',
  fontSize: '15px',
  fontWeight: '500',
  padding: '10px 10px 10px 20px',
  '&:hover' : {
    backgroundColor: 'rgba(235, 245, 255, 1)'
  },
});

export const BackButton = styled(ButtonMui)({
  color: '#0675DD',
  textTransform: 'none',
  fontSize: 14,
  fontWeight: 500,
  height: 26.5,
  '.MuiButton-startIcon': {
    marginTop: -1
  }
});